import { Headers, RequestOptions, Http } from "@angular/http";
import { Injectable } from '@angular/core';
import { ENV } from '@app/env'
import { map } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable()
export class StiProvider {

  constructor(public http: Http) {}

  async getToken()  {
    return new Promise((resolve, reject) => {
      var headers = new Headers()
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      let options = new RequestOptions({ headers: headers });
      let body = `grant_type=${ENV.STI_CONFIG.grant_type}&client_id=${ENV.STI_CONFIG.client_id}&client_secret=${ENV.STI_CONFIG.client_secret}`;
      this.http.post(`${ENV.STI_CONFIG.token_url_prod}`, body, options)
      // .pipe(
      //   map(res => res.json()) // or any other operator
      // )
      .subscribe(
      (data) => {
        console.log('Data Returned: ', data)
      },
      (err) => {
          if (err.status === 401) {
            reject(new Error('You currently don’t have access. Please contact support'));
          }
          else if (err.status === 403) {
            reject(new Error("Your access is forbidden."));
          }
          else if (err.status === 500) {
            reject(new Error("Application error: " + err));
          }
          else {
            reject(new Error("Could not get a token from the server."));
          }
      });
    });
  }

  async getEnrolment(token: any, patient: any, coveragetype: string)  {
    const request = {
      "enrollmentType": "PATIENT_ASSISTED",
      "benefit": {
          "rate": 100,
          "limit": 9999,
          "benefitSource": "FMT",
          "program": {
              "programId": "12516"
          }
      },
      "patient": {
          "person": {
              "contactInfo": {
                  "firstName": patient.first_name,
                  "lastName": patient.last_name
              },
              "address": {
                  "locationLine1": patient.address ? patient.address : null,
                  "postalCode": patient.postal_code ? patient.postal_code : null,
                  "city": patient.city ? patient.city : null,
                  "provinceCode": patient.province ? patient.province : null,
                  "countryCode": "CA"
              },
              "dateOfBirth": patient.dob ? moment(patient.province).format('YYYY-MM-DD') : null,
              "preferredLanguage": patient.language ? patient.language : null,
              "gender": patient.gender ? patient.gender : null
          },
          "insurance": {
              "coverageType": coveragetype
          }
      },
      "enrollmentOptions": [{
              "name": "LEVIMA_TERMS_AND_CONDITIONS_V1",
              "value": "true"}]
    }
  }

  async getEnrolmentProcess() {

  }

  async getUCI()  {
    
  }

}



// WEBPACK FOOTER //
// ./src/providers/sti/sti.ts